import {
  CONTENTTYPE_IDENTITY,
  CONTENTTYPE_EMPLOYER,
  CONTENTTYPE_CLIENT,
  CONTENTTYPE_CASE,
  CONTENTTYPE_FILE,
  CONTENTTYPE_EMAIL,
  CONTENTTYPE_MESSAGE,
  CONTENTTYPE_REQUESTRUN,
  CONTENTTYPE_PAYROLLRUN,
  CONTENTTYPE_WHATSAPPMESSAGE
} from '../../constants'

export const prefix = (classname) =>
    classname.split(' ').map(name =>
        name = ('slds-').concat(name)
    ).join(' ').replace(',', ' ')

export const className = (...a) =>
    a.join(' ').replace(',', ' ')

export const decodeBase64 = (encoded) => {
  let decoded = window.atob(encoded)
  return decoded.split(":")[1]
}

export const encodeBase64 = (decodedId, node) => {
  let encoded = node+':'+decodedId
  return window.btoa(encoded)
}

export const isBase64 = (string) => {
  try {
    return btoa(atob(string)) == string  // eslint-disable-line eqeqeq
  } catch (error) {
    return false
  }
}

export const getNodeTypeFromBase64Id = (encoded) => {
  let decoded = window.atob(encoded)
  return decoded.split(":")[0]
}

export const getDateOfBirthFromSouthAfricanID = (idNumber, moment) => {
  let m = moment ? moment : require('moment')
  let today = m()
  // set date of birth (dob) from first 6 digits of id (assuming 'za_id')
  let dob = m().set({
    "date": idNumber.slice(4,6),
    "month": idNumber.slice(2,4) - 1,
    // assuming that when 2 digit year corresponds to being less than today
    // minus 100 yrs, dob is in the 2000's else assumed to be in the 1900's
    "year": idNumber.slice(0,2) < parseInt(m().year(today.year() - 100).format("YY"), 10)
      ? "20" + idNumber.slice(0,2)
      : "19" + idNumber.slice(0,2)
  })

  return dob
}

// checks the validity of a number (An attempt to solve the insanity of JavaScript numbers)
export const checkValidNumber = (number) => {
  let numbers_only = new RegExp('^\\d+$')
  return number !== ''
    && numbers_only.test(number)
    && !Number.isNaN(Number(number))
}

// check that number is a phone number that starts with 0 and approximate length
export const isValidPhoneNumber = (number, minLength, maxLength) => {
  return checkValidNumber(number)
    && number[0] === '0'
    && number.length >= minLength
    && number.length <= maxLength
}

// returns phone number as 'readable' (country code effectively replaced with '0')
export const readablePhoneNumber = (number) => {
    let countryCode = '+27'

    if (number === '') {
      return number
    }

    switch (['+','0','*'].indexOf(number[0])) {
      case 0:  // number starts with '+', i.e. +27821234...
        return number[3] === '0' // in case of +27(0)821234...
          ? number.replace(countryCode+'0', '0')
          : number.replace(countryCode, '0')

      case 1:  // number starts with '0', i.e. 0821234...
        return number  // assuming number already readable

      case 2:  // short- or longcodes
        return number

      default:  // number starts with some other digit, i.e. 27821234
        number = '+' + number
        return number.replace(countryCode, '0')
    }
}

// normalizes phone number
export const normalizePhoneNumber = (raw) => {
  let countryCode = '27'

  if (raw[0] === '0') {
    return '+' + countryCode + raw.substr(1)
  }
  if (raw[0] === '+') {
    return raw
  }
  if (raw.substr(0, countryCode.length) === countryCode) {
    return '+' + raw
  }
  return raw
}

// will group by thousands, displaying 1000 as 1 000, 1000000 as 1 000 000
export const formatCurrency = (amountToFormat) => {
  let amount = typeof amountToFormat === 'number'
    ? amountToFormat.toString()
    : amountToFormat

  if (amount === undefined) {
    return null
  } else if (isNaN(amount)) {
    throw new Error("Parameter is not a number!")
  } else {
    return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }
}

export const roundToDecimals = (amountToRound, decimals) => {
  let amount = typeof amountToRound === 'string'
    ? parseFloat(amountToRound)
    : amountToRound
  return decimals > 0
    ? Number(Math.round(amount + `e${decimals}`) + `e-${decimals}`).toFixed(decimals)
    : amount
}

export const showAsCurrency = (currencySymbol, amountToShow, decimals, format) => {
  let amount = amountToShow ? amountToShow : '0'
  if (currencySymbol) {
    return `${currencySymbol} ${format ? formatCurrency(roundToDecimals(amount, decimals)) : roundToDecimals(amount, decimals !== undefined ? decimals : 2)}`
  } else {
    throw new Error('Invalid currency symbol specified')
  }
}

export const isValidSouthAfricanID = (idNumber, moment) => {
  let m = moment ? moment : require('moment')

  let i
  let c
  let even = ''
  let sum = 0
  let check = idNumber.slice(-1)

  if (idNumber.length !== 13 || idNumber.match(/\D/)) {
    return false
  }
  if (!m(idNumber.slice(0,6), 'YYMMDD', true).isValid()) {
    return false
  }

  idNumber = idNumber.substr(0, idNumber.length - 1)
  for (i = 0; idNumber.charAt(i); i += 2) {
    c = idNumber.charAt(i)
    sum += +c
    even += idNumber.charAt(i + 1)
  }
  even = '' + even * 2;
  for (i = 0; even.charAt(i); i++) {
    c = even.charAt(i)
    sum += +c
  }
  sum = 10 - ('' + sum).charAt(1)

  return ('' + sum).slice(-1) === check
}

export const upperCaseFirstCharacter = (string) => (
  string.charAt(0).toUpperCase() + string.slice(1)
)

export const getContentTypeFromNodeType = (nodeType) => (
  {
    "IdentityNode": CONTENTTYPE_IDENTITY,
    "EmployerNode": CONTENTTYPE_EMPLOYER,
    "ClientNode": CONTENTTYPE_CLIENT,
    "CaseNode": CONTENTTYPE_CASE,
    "FileNode": CONTENTTYPE_FILE,
    "EmailNode": CONTENTTYPE_EMAIL,
    "MessageNode": CONTENTTYPE_MESSAGE,
    "RequestRunNode": CONTENTTYPE_REQUESTRUN,
    "PayrollRunNode": CONTENTTYPE_PAYROLLRUN,
    "WhatsappMessageNode": CONTENTTYPE_WHATSAPPMESSAGE
  }[nodeType]
)



// WEBPACK FOOTER //
// ./src/utils/string/index.js